export default __webpack_public_path__ + "static/media/drawn-wind-turbine-highlighted-existing-icon.6feff47a.svg";